import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-magnet",
  "use": "icon-si-glyph-magnet-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-magnet\" id=\"icon-si-glyph-magnet\"><title>1074</title><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(-40.000000, 0.000000)\" fill=\"#434343\"><g transform=\"translate(41.000000, 0.000000)\"><rect x=\"0\" y=\"0\" width=\"3\" height=\"2.953\" class=\"si-glyph-fill\" /><rect x=\"13\" y=\"0\" width=\"3\" height=\"2.953\" class=\"si-glyph-fill\" /><path d=\"M8.016,15.917 C3.682,15.917 0.034,12.573 0.034,8.463 L0.034,4.031 L2.97,4.031 L2.97,7.917 C2.97,10.825 5.2,13.047 8.017,13.047 C10.843,13.047 13.033,10.732 13.033,7.917 L13.033,4.031 L15.969,4.031 L15.969,8.463 C15.967,12.503 12.393,15.917 8.016,15.917 L8.016,15.917 Z\" class=\"si-glyph-fill\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-magnet.svg
// module id = 9Ujw
// module chunks = 62